import './App.css';
import Header from './components/Header/Header';
import Main from './components/Main/Main';
import About from './components/About/About';
import './fonts/Lato/stylesheet.css'
import Why from './components/Why/Why';
import Integration from './components/Integration/Integration';
import Roadmap from './components/Roadmap/Roadmap';
import Team from './components/Team/Team';
import How from './components/How/How';
import NutsToken from './components/NutsToken/NutsToken';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <div className='App'>
      <Header />
      <Main />
      <About />
      <Why />
      <Integration />
      <Roadmap />
      <Team />
      <How />
      <NutsToken />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
